import * as React from 'react';
import * as uuid from 'uuid';

function SvgEchIconsUxTree(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = uuid.v4();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
      <g>
        <linearGradient
          id={`${iconUuid}_a`}
          x1={60.378}
          x2={27.3}
          y1={99.804}
          y2={8.924}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={0.011} stopColor="#ec6608" />
          <stop offset={0.656} stopColor="#f18617" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
        <path
          fill={`url(#${iconUuid}_a)`}
          d="M85.2 77.7L66.7 48.8h12.4L50.1.6l-29 48.2h12.4L15.1 77.7h25.5V100h19.1V77.7h25.5zM42.6 43.8H29.9l20.2-33.5 20.2 33.5H57.6L76 72.7H24.2l18.4-28.9zm12.1 51.3h-9.1V77.7h9.1v17.4z"
        />
      </g>
    </svg>
  );
}
export default SvgEchIconsUxTree;
